function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment, memo } from 'react';
import { withTheme } from 'styled-components';
import { getPeriod, getFundsSheetPath, getProductTypeById } from '@finect/front-resources/Products';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { H5 } from '@finect/tabular-core/Headings';
import { Small } from '@finect/tabular-core/Small';
import { Tabs, TabsPane } from '../../Tabs';
import { Table } from '../../Table';
import { Modal } from '../../Modal';
import { Collapsible, CollapsibleContent } from '../../Collapsible';
import { TimeseriesComparisonChart, ProductFinder, UserComparisonsModal, ComparisonWelcomeBanner } from '../../Products';
import { Inner as ClassInner, Content, ResultName } from '../../Products/ProductFinder/Result/partials';
import { getPerformanceRows, getMetaRows, getColumns, getFeesRows, getVolatilityRows, getBreakdownsRows } from './utils';
import { Inner, ModalInner, ComparisonHeader, Footnotes } from './partials';
import { SonIA } from './SonIA';
import { FooterTip } from './FooterTip';
var SuperComparison = function (_React$Component) {
  _inherits(SuperComparison, _React$Component);
  var _super = _createSuper(SuperComparison);
  function SuperComparison() {
    var _this;
    _classCallCheck(this, SuperComparison);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      changeClass: null,
      searching: false,
      saved: false,
      scrollLeft: 0
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpenProductFinder", function () {
      _this.setState({
        searching: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseProductFinder", function () {
      _this.setState({
        searching: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleRemoveProduct", function (product) {
      _this.props.onRemoveProduct(product);
      _this.setState({
        saved: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleProductFinderChange", function (selected) {
      var fundProductType = getProductTypeById(selected.subtype);
      _this.props.onAddProduct(fundProductType, selected.entity);
      _this.setState({
        saved: false
      });
      _this.handleCloseProductFinder();
    });
    _defineProperty(_assertThisInitialized(_this), "handleSaveSearch", function () {
      _this.props.onSave();
      _this.setState({
        saved: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDeleteSearch", function () {
      _this.props.onDelete();
      _this.setState({
        saved: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleHorizontalScroll", function (scrollLeft) {
      _this.setState({
        scrollLeft: scrollLeft
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectSession", function (session) {
      _this.props.onSelectSession(session);
      _this.setState({
        saved: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDeleteSession", function (session) {
      _this.props.onDeleteSession(session);
    });
    _defineProperty(_assertThisInitialized(_this), "handleClearComparison", function () {
      _this.props.fetchUserComparisons();
      _this.props.funds.forEach(function (fund) {
        return _this.props.onRemoveProduct(fund);
      });
      _this.setState({
        saved: false
      });
      window.history.replaceState(null, null, window.location.pathname);
    });
    _defineProperty(_assertThisInitialized(_this), "handleChangeClassModal", function (fund) {
      _this.setState({
        changeClass: fund
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChangeClass", function (newClass) {
      _this.props.onChangeClass && _this.props.onChangeClass(_this.state.changeClass, newClass);
      _this.setState({
        changeClass: null,
        saved: false
      });
    });
    return _this;
  }
  _createClass(SuperComparison, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        productType = _this$props.productType,
        funds = _this$props.funds,
        theme = _this$props.theme,
        _this$props$inPill = _this$props.inPill,
        inPill = _this$props$inPill === void 0 ? false : _this$props$inPill,
        userComparisons = _this$props.userComparisons,
        handleProductRequest = _this$props.handleProductRequest,
        comparisonsDialog = _this$props.comparisonsDialog,
        _this$props$collapseW = _this$props.collapseWithoutData,
        collapseWithoutData = _this$props$collapseW === void 0 ? false : _this$props$collapseW,
        shareTitle = _this$props.shareTitle,
        shareUrl = _this$props.shareUrl,
        sonIA = _this$props.sonIA;
      var getSheetPath = function getSheetPath(fundProductType, product) {
        return getFundsSheetPath(theme, fundProductType, product);
      };
      var columns = getColumns(funds);
      var performanceRows = getPerformanceRows(null, funds, inPill, getSheetPath);
      var breakdownsRows = getBreakdownsRows(null, funds, inPill, getSheetPath);
      var feesRows = getFeesRows(null, funds, inPill, getSheetPath);
      var periods = ['M12', 'M36', 'M60'];
      var tabs = periods.map(function (period) {
        return {
          period: period,
          title: getPeriod(period).tableLabel,
          volatilityRows: getVolatilityRows(null, funds, period, inPill)
        };
      });
      var metaRows = getMetaRows(theme, null, funds, inPill, handleProductRequest ? handleProductRequest : null, getSheetPath, this.handleOpenProductFinder, this.handleRemoveProduct, this.handleChangeClassModal);
      var collapsed = collapseWithoutData ? funds.length === 0 : false;
      return React.createElement(Fragment, null, this.state.searching ? React.createElement(Modal, {
        onClose: this.handleCloseProductFinder
      }, React.createElement("div", {
        style: {
          marginTop: 0
        }
      }, React.createElement(ProductFinder, {
        user: this.props.user,
        productType: productType,
        filterByProductType: false,
        title: "A\xF1adir un producto",
        multiple: false,
        limit: 5,
        onChange: this.handleProductFinderChange,
        initialSelection: [],
        autofocus: true,
        showAllProductTypes: true
      }))) : null, this.state.changeClass ? React.createElement(Modal, {
        onClose: function onClose() {
          return _this2.handleChangeClassModal(null);
        }
      }, React.createElement(ModalInner, null, React.createElement(H5, null, "Clases disponibles:"), this.state.changeClass.classes.map(function (item, i) {
        var _this2$state$changeCl;
        return React.createElement(ClassInner, {
          key: i,
          onClick: function onClick() {
            return _this2.handleChangeClass(item);
          },
          selected: item.isin === ((_this2$state$changeCl = _this2.state.changeClass) === null || _this2$state$changeCl === void 0 ? void 0 : _this2$state$changeCl.isin)
        }, React.createElement(Content, {
          onClick: function onClick() {
            return _this2.handleChangeClass(item);
          }
        }, React.createElement(ResultName, null, React.createElement(Small, null, item.isin), item.name)), React.createElement(ChevronRight, null));
      }))) : null, !inPill ? React.createElement(ComparisonHeader, {
        disabled: funds.length === 0,
        saved: this.state.saved,
        onSave: this.handleSaveSearch,
        onDelete: this.handleDeleteSearch,
        onUserComparisonsOpen: this.props.onOpenUserComparisonsDialog,
        onClearComparison: this.handleClearComparison,
        shareTitle: shareTitle,
        shareUrl: shareUrl
      }) : null, React.createElement(Inner, null, !inPill && funds.length === 0 ? React.createElement(ComparisonWelcomeBanner, {
        onSearchOpen: this.handleOpenProductFinder,
        productType: null
      }) : null, !inPill ? React.createElement(UserComparisonsModal, {
        userComparisons: userComparisons,
        sessions: userComparisons.models,
        onSelect: this.handleSelectSession,
        onDelete: this.handleDeleteSession,
        show: comparisonsDialog.open,
        onClose: this.props.onCloseUserComparisonsDialog
      }) : null, React.createElement(Collapsible, null, funds.length ? React.createElement(CollapsibleContent, {
        title: "Gr\xE1fico",
        collapsed: false,
        collapseDisabled: true
      }, React.createElement(TimeseriesComparisonChart, {
        key: funds.map(function (item) {
          return item.id;
        }).join('-'),
        products: funds,
        mode: "compare"
      })) : null, sonIA && React.createElement(SonIA, sonIA), React.createElement(CollapsibleContent, {
        title: "Datos b\xE1sicos",
        collapsed: false
      }, React.createElement(Table, {
        textAlign: "center",
        onHorizontalScroll: this.handleHorizontalScroll,
        scrollLeft: this.state.scrollLeft,
        columns: columns,
        rows: metaRows,
        noHead: true,
        small: true,
        firstColumnFixed: true,
        firstColumnAsTh: true
      })), React.createElement(CollapsibleContent, {
        title: "Rentabilidad",
        collapsed: collapsed
      }, React.createElement(Table, {
        textAlign: "right",
        onHorizontalScroll: this.handleHorizontalScroll,
        scrollLeft: this.state.scrollLeft,
        columns: columns,
        rows: performanceRows,
        noHead: true,
        small: true,
        firstColumnFixed: true,
        firstColumnAsTh: true
      }), React.createElement(Footnotes, {
        light: true
      }, "* Rentabilidad anualizada en Euros")), React.createElement(CollapsibleContent, {
        title: "Principales ratios",
        collapsed: collapsed
      }, React.createElement(Tabs, null, tabs.map(function (tab, i) {
        return React.createElement(TabsPane, {
          key: i,
          title: tab.title
        }, React.createElement(Table, {
          textAlign: "right",
          onHorizontalScroll: _this2.handleHorizontalScroll,
          scrollLeft: _this2.state.scrollLeft,
          columns: columns,
          rows: tab.volatilityRows,
          noHead: true,
          small: true,
          firstColumnFixed: true,
          firstColumnAsTh: true
        }));
      })), React.createElement(FooterTip, null)), React.createElement(CollapsibleContent, {
        title: "Asignaci\xF3n de activos",
        collapsed: collapsed
      }, React.createElement(Table, {
        textAlign: "center",
        onHorizontalScroll: this.handleHorizontalScroll,
        scrollLeft: this.state.scrollLeft,
        columns: columns,
        rows: breakdownsRows,
        noHead: true,
        small: true,
        firstColumnFixed: true,
        firstColumnAsTh: true
      })), React.createElement(CollapsibleContent, {
        title: "Comercializaci\xF3n",
        collapsed: collapsed
      }, React.createElement(Table, {
        textAlign: "right",
        onHorizontalScroll: this.handleHorizontalScroll,
        scrollLeft: this.state.scrollLeft,
        columns: columns,
        rows: feesRows,
        noHead: true,
        small: true,
        firstColumnFixed: true,
        firstColumnAsTh: true
      })))));
    }
  }]);
  return SuperComparison;
}(React.Component);
_defineProperty(SuperComparison, "defaultProps", {
  userComparisons: {
    fetching: false,
    fetched: false,
    models: []
  }
});
export default memo(withTheme(SuperComparison));